import bBadge from './badge';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bBadge: bBadge
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/badge/index.js
// module id = 1etr
// module chunks = 17